import React from 'react'

/* container */
import FaqContainer from '../../app-module-faq-container/default'
/* container */

import Contents from '../contents/contents'

import ScrollToTop from '../../../scrollToTop'

const index = (props) => {
  return (
    <FaqContainer {...props}>
      <ScrollToTop {...props} />
      <Contents {...props} />
    </FaqContainer>
  )
}

export default index
